import qs from 'qs';
import axios from 'axios';
import { Search } from '../../pages/types';

declare global {
  interface Navigator {
    msSaveBlob?: any;
  }
}

export function convertToFileDownload(b64Data: string, filename: string) {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: 'application/octet-stream' });

  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    // IE workaround for "HTML7007: One or more blob URLs were
    // revoked by closing the blob for which they were created.
    // These URLs will no longer resolve as the data backing
    // the URL has been freed."
    window.navigator.msSaveBlob(blob, filename);
  } else {
    const blobURL = window.URL.createObjectURL(blob);
    const tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = blobURL;
    tempLink.setAttribute('download', filename);

    // Safari thinks _blank anchor are pop ups. We only want to set _blank
    // target if the browser does not support the HTML5 download attribute.
    // This allows you to download files in desktop safari if pop up blocking
    // is enabled.
    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank');
    }

    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(blobURL);
  }
}

export async function downloadDocument(documentId: number) {
  const queryString = qs.stringify({ documentId });
  const { data } = await axios.get(`/api/clientdownload/downloadfile?${queryString}`);
  convertToFileDownload(data.base64, data.fileName);
}

export async function downloadSearchDocuments(
  title: string,
  merge: boolean,
  searchType: string,
  searchId: number
) {
  const data = await getSearchIdData(title, merge, searchType, searchId);
  convertToFileDownload(data.base64, data.fileName);
}

export async function getSearchIdData(title: string, merge: boolean, searchType: string, searchId: number) {
  const queryString = qs.stringify({ title, merge, searchType, searchId });
  const { data } = await axios.get(`/api/clientdownload/downloadSearchDocuments?${queryString}`);
  return data;
}

export async function getUrlForBase64(
  title: string,
  merge: boolean,
  searchType: string,
  searchId: number,
  type: string = 'application/pdf'
) {
  const data = await getSearchIdData(title, merge, searchType, searchId);
  var binary_string = window.atob(data.base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return URL.createObjectURL(new Blob([bytes.buffer], { type }));
}

export async function downloadOrderDocuments(title: string, merge: boolean, searches: Search[]) {
  const queryString = qs.stringify({ title, merge });
  const { data } = await axios.post(`/api/clientdownload/downloadOrderDocuments?${queryString}`, searches);
  convertToFileDownload(data.base64, data.fileName);
}
